// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import React from 'react';
import styles from './InfoBlock.module.scss';
import { mergeClasses } from 'util/commons';

interface InfoBlockProps {
  title: string;
  className?: string;
  children?: React.ReactNode;
}

export const InfoBlock = ({ title, className, children }: InfoBlockProps) => {
  return (
    <div className={mergeClasses(styles.infoBlock, className)}>
      <div className={styles.header}>
        <div className={styles.border}></div>
        <h3>{title}</h3>
      </div>

      {children}
    </div>
  );
};
